var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchAnim(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eqJznh21xtI1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 300",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eqJznh21xtI12-fill",
    x1: 85.7588,
    y1: 147.9714,
    x2: 145.7898,
    y2: 37.2513,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eqJznh21xtI12-fill-0",
    offset: "0%",
    stopColor: "rgba(237,25,68,0)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqJznh21xtI12-fill-1",
    offset: "100%",
    stopColor: "#ed1944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eqJznh21xtI13-fill",
    x1: 150,
    y1: 92.4622,
    x2: 150,
    y2: 92.4622,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eqJznh21xtI13-fill-0",
    offset: "0%",
    stopColor: "rgba(237,25,68,0)"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqJznh21xtI13-fill-1",
    offset: "100%",
    stopColor: "#ed1944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eqJznh21xtI21-fill",
    x1: -7.2582,
    y1: 0.0495,
    x2: 7.2476,
    y2: 0.0495,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eqJznh21xtI21-fill-0",
    offset: "0%",
    stopColor: "#ed1944"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eqJznh21xtI21-fill-1",
    offset: "100%",
    stopColor: "#ed1944"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.952748-.187003)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    r: 130.8,
    transform: "translate(149.047252 150)",
    fill: "none",
    stroke: "#5e6367",
    strokeWidth: 16.6789
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 282.7,
    x2: 150,
    y2: 18,
    transform: "translate(-.952748 0)",
    fill: "none",
    stroke: "#5e6367",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.6,
    y1: 150.4,
    x2: 282.4,
    y2: 150.4,
    transform: "translate(0-.212997)",
    fill: "none",
    stroke: "#5e6367",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 96.7,
    transform: "translate(150 150)",
    fill: "none",
    stroke: "#5e6367",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 34.5,
    transform: "translate(150 150.4)",
    fill: "none",
    stroke: "#5e6367",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 64.5,
    transform: "translate(150 150)",
    fill: "none",
    stroke: "#5e6367",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.340602-.261422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eqJznh21xtI11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.9,35.5c-63.1,0-114.2,51-114.5,114h114.5v-114Z",
    transform: "translate(-3.065467 0)",
    fill: "url(#eqJznh21xtI12-fill)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 149.5,
    x2: 150,
    y2: 35.4,
    transform: "translate(-1.293355 0)",
    fill: "url(#eqJznh21xtI13-fill)",
    stroke: "#ed1944",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "eqJznh21xtI15",
    r: 7.3,
    transform: "translate(96.1 113.8)",
    fill: "#ed1944"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "eqJznh21xtI17",
    r: 7.3,
    transform: "translate(175.6 172.6)",
    opacity: 0,
    fill: "#ed1944"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "eqJznh21xtI19",
    r: 7.3,
    transform: "translate(223.8 87)",
    opacity: 0,
    fill: "#ed1944"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "eqJznh21xtI21",
    r: 7.3,
    transform: "translate(208.2 227.1)",
    opacity: 0,
    fill: "url(#eqJznh21xtI21-fill)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchAnim);
export default __webpack_public_path__ + "static/media/search_anim.fa1bdb7ff46f7681022c1e5838ce0e55.svg";
export { ForwardRef as ReactComponent };